import { Route, Routes } from 'react-router-dom';
import { EditorContainer as Editor } from '../../containers/Editor.container';
import { Wrapper } from './PageEditor.style';

export type PageEditorProps = {};

export function PageEditor(props: PageEditorProps) {
  return (
    <Wrapper className='PageEditor-wrapper' data-testid='PageEditor-wrapper'>
      <Routes>
        <Route path='/' element={<Editor />} />
        <Route path='/:projectId' element={<Editor />} />
        <Route path='/:projectId/:modelId' element={<Editor />} />
        <Route path='/packs/:packId' element={<Editor />} />
        <Route path='/generators/:generateId' element={<Editor />} />
      </Routes>
    </Wrapper>
  );
}

export default PageEditor;
